export var nsmgr = null;

export class ptr {
	constructor() {
		this.reset();
	}

	reset() {
		this.documentType = "Unknown";
		this.pointersLoaded = false;
		this.errors = [];
		this.warnings = [];
		this.lookupValue = null;

		this.nsmgr = null;
		this.appraisalDocument = null;
		this.views = null;
		this.appraisal = null;
		this.parties = null;
		this.relationships = null;
		this.signatories = null;
		this.valRpt = null;
		this.valDetail = null;
		this.sow = null;
		this.sowDetail = null;
		this.valRecon = null;
		this.valReconDetail = null;
		this.valSum = null;
		this.valSumDetail = null;
		this.dataSources = null;
		this.approachToValue = null;
		this.incomeApproach = null;
		this.incomeDetail = null;
		this.costApproach = null;
		this.costDetail = null;

		this.subProp = null;
		this.subProj = null;
		this.subTax = null;
		this.subSales = null;
		this.subDetail = null;
		this.subInsp = null;

		// other report types go here
		this.subLivingUnitCount = 0;
		this.anyLivingUnitCountGTOne = false;
		this.subImprovs = null;
		this.subDwellingList = [];
		this.subDwelling = null;
		this.subOutbuildingList = [];

		this.subSite = null;
		this.siteDetail = null;

		this.compList = [];
		this.compCount = null;
		this.compRentList = [];
		this.compMultList = [];
		this.compLandList = [];

		// pointers for iterations

		this.dwelling = null;		// current dwelling - Improvement
		this.structure = null;
		this.stDetail = null;
		this.propertyUnit = null;
		this.unitDetail = null;
		this.propertyUnitArea = null;
		this.rentControlDescription = "";
		this.bRentControl = false;
		this.rentActualIncomeRentTotal = 0;
		this.rentActualIncomeOtherTotal = 0;
		this.rentOpinionOfIncomeRentTotal = 0;
		this.rentOpinionOfIncomeOtherTotal = 0;
		this.tempTotal = 0;		// used to accumulate table totals
	}
	
	init(ad) {
		this.appraisalDocument = ad;
		this.views = this.appraisalDocument.views;
		this.valuation = this.appraisalDocument.services.GetServiceByType("Valuation");
		this.inspection = this.appraisalDocument.services.GetServiceByType("Inspection");
		this.parties = this.valuation.parties;
		this.relationships = this.valuation.relationships;
		this.signatories = this.appraisalDocument.signatories;
		this.documentClassification = this.appraisalDocument.documentClassification;
		this.documentType = this.appraisalDocument.GetDocumentType();
		if (this.documentType !== "AppraisalReport") return;

		this.inspectionService = this.inspection?.inspectionService ?? null;
		this.valuationAnalysis = this.valuation.valuationAnalysis;

		this.valRpt = this.valuationAnalysis.valuationReport;
		this.valDetail = this.valRpt.valuationReportDetail;
		this.sow = this.valRpt.scopeOfWork;
		this.sowDetail = this.sow.scopeOfWorkDetail;
		this.valRecon = this.valRpt.valuationReconciliation;
		this.valReconDetail = this.valRecon.valuationReconciliationDetail;
		this.valSum = this.valRecon.valuationReconciliationSummary;
		this.valSumDetail = this.valSum.valuationReconciliationSummaryDetail;
 		this.dataSources = this.valuationAnalysis.dataSources;
		this.approachToValue = this.valRpt.approachToValue;
		this.incomeApproach = this.approachToValue.incomeApproach;
		this.incomeDetail = this.incomeApproach.incomeApproachDetail;
		this.costApproach = this.approachToValue.costApproach;
		this.costDetail = this.costApproach.costApproachDetail;

		this.subProp = this.valuationAnalysis.subjectProperty;
		this.subProj = this.subProp.project;
		this.subTax = this.subProp.propertyTaxes;
		this.subSales = this.subProp.sales;
		this.subDetail = this.subProp.propertyDetail;
		this.subInsp = this.subProp.GetInspection("");    // get main inspection
		// other report types go here
		this.subLivingUnitCount = Number(this.subDetail.livingUnitExcludingADUCount);
		this.anyLivingUnitCountGTOne = false;


		this.valRecon = this.valRpt.valuationReconciliation;
		this.valReconDetail = this.valRecon.valuationReconciliationDetail;
		this.valSum = this.valRecon.valuationReconciliationSummary;
		//console.log("valSum: ", this.valSum);
		this.valSumDetail = this.valSum.valuationReconciliationSummaryDetail;

		this.subImprovs = this.subProp.improvements;
		this.subImprovsList = this.subImprovs.improvementList;;
		this.subImprov = this.subImprovsList[0];
		//console.log("si: ", this.subImprov);
		this.subImprovDetail = this.subImprov.improvementDetail;
		this.subDwellingList = this.subImprovs.GetImprovementsByType("Dwelling");
		this.subDwelling = this.subDwellingList[0];
		this.subOutbuildingList = this.subImprovs.GetImprovementsByType("Outbuilding");
		this.subOutbuildingList.sort((a, b) => a.GetOutbuildingType().localeCompare( b.GetOutbuildingType()));

		this.subSite = this.subProp.site;
		//console.log("site: ", this.subSite);
		this.siteDetail = this.subSite.siteDetail;

		//console.log("ptr: ", this.valuationAnalysis.salesComparables);
		//console.log("ptr: ", this.valuationAnalysis.salesComparables.comparablePropertyList);
		this.compList = this.valuationAnalysis.salesComparables.comparablePropertyList.sort((a, b)=> a.comparable.comparableDetail.propertyOrdinalNumber - b.comparable.comparableDetail.propertyOrdinalNumber);
		this.compCount = this.compList.length;
		this.compRentList = this.valuationAnalysis.rentalComparables.comparableRentalList.sort((a, b)=> a.comparable.comparableDetail.propertyOrdinalNumber - b.comparable.comparableDetail.propertyOrdinalNumber);
		this.compMultList = this.valuationAnalysis.multiplierComparables.comparableMultiplierList.sort((a, b)=> a.comparable.comparableDetail.propertyOrdinalNumber - b.comparable.comparableDetail.propertyOrdinalNumber);
		this.compLandList = this.valuationAnalysis.landComparables.comparablePropertyList.sort((a, b)=> a.comparable.comparableDetail.propertyOrdinalNumber - b.comparable.comparableDetail.propertyOrdinalNumber);

		this.govtAppraisalType = this.sowDetail.governmentAgencyAppraisalType;
		this.bGovAgency = this.sowDetail.governmentAgencyAppraisalIndicator ?? false;
		this.bFHA = this.govtAppraisalType === "FHA";
		this.bUSDA = this.govtAppraisalType === "USDA";
		this.bVA = this.govtAppraisalType === "VA";
		this.bCostApproach = this.sowDetail.costApproachIndicator ?? false;

		this.bPurchase = this.sowDetail.valuationAssignmentType === "Purchase";
		this.bRefinance = this.sowDetail.valuationAssignmentType === "Refinance";
		this.bInProject = (this.subDetail.propertyInProjectIndicator ?? false);
		this.bPUD = (this.subDetail.PUDIndicator ?? false);

		this.bOwnedInCommon = this.subSite.siteDetail.landOwnedInCommonIndicator;
		this.bMixedUsage = this.subProp.propertyUseSummary?.propertyMixedUsageIndicator ?? false;
		//console.log(this.bOwnedInCommon, this.subProp, this.subSite.siteDetail);

		this.govtAppraisalType = this.sowDetail.governmentAgencyAppraisalType;
		this.bGovAgency = this.sowDetail.governmentAgencyAppraisalIndicator ?? false;
		this.bFHA = this.govtAppraisalType === "FHA";
		this.bUSDA = this.govtAppraisalType === "USDA";
		this.bVA = this.govtAppraisalType === "VA";
		this.bCostApproach = this.sowDetail.costApproachIndicator ?? false;

		this.bListedWithinPreviousYear = this.subProp.listingInformationSummary.listedWithinPreviousYearIndicator ?? false;
		this.structureType = this.bInProject ? this.subProp.project.projectDetail.projectLegalStructureType : "";
		this.bCondominium = this.structureType === "Condominium";
		this.bCooperative = this.structureType === "Cooperative";
		this.bCondop = this.structureType === "Condop";
		this.bIsRise = this.subImprov.GetStructureIsRise();

	  this.bLeasehold = this.subDetail.propertyEstateType === "Leasehold";
		this.bAppraisedIndicator = 
		this.bRightsAppraised = this.subProp.sales.salesContracts[0].salesContractDetail.allPropertyRightsAppraisedIndicator ?? false;
    this.bGroundRent = (this.subProp.propertyGroundRent !== null);

		// inits to prevent traps
		this.propertyUnit = this.subDwelling.propertyUnits[0];
		this.unitDetail = this.propertyUnit.propertyUnitDetail;
		this.propertyUnitArea = this.propertyUnit.propertyUnitArea;
		this.outbuilding = null;	// current outbuilding (if any);
		this.outbuildingDetail = null;	// current outbuilding (if any);

		// calculated globals
		if (this.subLivingUnitCount > 1)
			this.anyLivingUnitCountGTOne = true;
		else {
			for (let cp of this.compList)
				if (Number(cp.propertyDetail.livingUnitExcludingADUCount) > 1) this.anyLivingUnitCountGTOne = true;
		}

		this.pointersLoaded = true;
	}
}

//global.ptr = new ptr();

export function setNS(ns) {
	console.log("pointersNS: ", ns);
	nsmgr = ns;
}

